import { lazy } from 'react';

const ApproveForGuardiansModal = lazy(() =>
  import('modules/PersonalizedPlans/modals/ApproveForGuardiansModal'),
);

const ConfirmEditPlanModal = lazy(() =>
  import('modules/PersonalizedPlans/modals/ConfirmEditPlanModal'),
);

const FinalizeSubmissionModal = lazy(() =>
  import('modules/PersonalizedPlans/modals/FinalizeSubmissionModal'),
);

const IlpFormSurveyModal = lazy(() =>
  import('modules/PersonalizedPlans/modals/IlpFormSurveyModal'),
);

const SimilarCareersModal = lazy(() =>
  import('modules/PersonalizedPlans/modals/SimilarCareersModal'),
);

export default {
  APPROVE_FOR_GUARDIANS_MODAL: ApproveForGuardiansModal,
  CONFIRM_EDIT_PLAN_MODAL: ConfirmEditPlanModal,
  ILP_FORM_SURVEY_MODAL: IlpFormSurveyModal,
  FINALIZE_SUBMISSION_MODAL: FinalizeSubmissionModal,
  SIMILAR_CAREERS_MODAL: SimilarCareersModal,
};
